import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiCheckCircle, FiArrowRight } from '../common/Icons';
import VidalyticsPlayer from './VidalyticsPlayer';

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="relative pt-32 pb-20 bg-black-pure overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-mesh-dark opacity-50 pointer-events-none"></div>
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          <motion.div 
            initial={{ opacity: 0, y: 10 }} 
            animate={{ opacity: 1, y: 0 }} 
            className="inline-flex items-center space-x-2 bg-orange-500/10 border border-orange-500/20 px-4 py-2 rounded-full mb-8"
          >
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-orange-500"></span>
            </span>
            <span className="text-orange-400 font-black text-[10px] uppercase tracking-[0.2em] italic">Webinar Esclusivo 2026</span>
          </motion.div>

          <motion.h1 
            initial={{ opacity: 0, y: 20 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ delay: 0.1 }}
            className="text-5xl md:text-8xl font-black text-white leading-[1.05] mb-6 tracking-tighter"
          >
            Sblocca <span className="text-gradient">AI Money Models</span>
          </motion.h1>

          <motion.p 
            initial={{ opacity: 0, y: 20 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ delay: 0.2 }}
            className="text-lg md:text-xl text-slate-400 mb-10 max-w-2xl mx-auto font-medium"
          >
            Guarda il Webinar qui sotto e ottieni la Mappa Operativa per dominare la tua nicchia.
          </motion.p>

          <motion.div 
            initial={{ opacity: 0, scale: 0.95 }} 
            animate={{ opacity: 1, scale: 1 }} 
            transition={{ delay: 0.3 }}
            className="max-w-4xl mx-auto mb-12 relative group vsl-glow"
          >
            <VidalyticsPlayer />
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, y: 20 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ delay: 0.4 }}
            className="flex flex-col sm:flex-row items-center justify-center gap-6"
          >
            <button onClick={() => navigate('/survey')} className="btn-premium text-white px-10 py-5 rounded-2xl font-black text-xl flex items-center space-x-3 w-full sm:w-auto justify-center shadow-[0_0_30px_rgba(249,115,22,0.4)]">
              <span>Inizia il Test Ora</span>
              <SafeIcon icon={FiArrowRight} />
            </button>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0 }} 
            animate={{ opacity: 1 }} 
            transition={{ delay: 0.6 }}
            className="mt-12 flex flex-wrap justify-center gap-6 text-slate-500"
          >
            {['No Competenze Tech', 'Mappa Step-by-Step', 'Template Copia-Incolla'].map((text, i) => (
              <div key={i} className="flex items-center space-x-2">
                <SafeIcon icon={FiCheckCircle} className="text-orange-500 w-4 h-4" />
                <span className="text-[10px] md:text-xs font-bold uppercase tracking-widest">{text}</span>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;